<ng-container *transloco="let t">
  @for (channel of channelSettings(); track channel) {
    <rma-icon
      class="rounded border border-steel-10 p-2"
      [glyph]="channel.name | channelIcon: channel.useBaseIcon"
      [matTooltip]="t(channel.name | channelName)"
      [size]="iconSize()"
      matTooltipPosition="below"
    />
  }
</ng-container>
